var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import PRODUCT_TYPE from "../../../const/productType";
var getRevolvingCreditDataSections = function (accountSummaryData, autopayStatusData, t) {
    var billing = accountSummaryData.billing, credit = accountSummaryData.credit, product = accountSummaryData.product;
    var isPLCC = (product === null || product === void 0 ? void 0 : product.type) === PRODUCT_TYPE.PRIVATE_LABEL;
    var cashAdvancedDataElements = [
        {
            value: credit === null || credit === void 0 ? void 0 : credit.availableCashLimit,
            label: t("grid.labels.cashAdvanceLimit"),
            type: "amount",
        },
        {
            value: credit === null || credit === void 0 ? void 0 : credit.cashAdvanceAnnualPercentageRate,
            label: t("grid.labels.cashAdvanceAPR"),
            type: "percentage",
        },
    ];
    return {
        dataSections: [
            {
                heading: t("grid.titles.payments"),
                sectionName: "payments",
                dataElements: [
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.nextPaymentDate,
                        label: t("grid.labels.nextPaymentDate"),
                        type: "date",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue,
                        label: t("grid.labels.totalMinimumPaymentDue"),
                        type: "amount",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentDate,
                        label: t("grid.labels.lastPaymentDate"),
                        type: "date",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentAmount,
                        label: t("grid.labels.lastPaymentAmount"),
                        type: "amount",
                    },
                    {
                        value: (autopayStatusData === null || autopayStatusData === void 0 ? void 0 : autopayStatusData.enrollment)
                            ? t("grid.labels.autoPayStatus.on")
                            : t("grid.labels.autoPayStatus.off"),
                        label: t("grid.labels.autoPayStatus.text"),
                        type: "text",
                    },
                ],
            },
            {
                heading: t("grid.titles.accountInformation"),
                sectionName: "account-information",
                dataElements: __spreadArray(__spreadArray([
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.interestChargedYearToDate,
                        label: t("grid.labels.interestChargedYearToDate"),
                        type: "amount",
                    },
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.annualPercentageRate,
                        label: t("grid.labels.purchaseAPR"),
                        type: "percentage",
                    }
                ], (!isPLCC ? __spreadArray([], cashAdvancedDataElements, true) : []), true), [
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.feesChargedYearToDate,
                        label: t("grid.labels.feesChargedYearToDate"),
                        type: "amount",
                    },
                ], false),
            },
        ],
    };
};
export default getRevolvingCreditDataSections;
//# sourceMappingURL=getRevolvingCreditDataSections.js.map